module.exports = __webpack_public_path__ + "img/picture-beautify.93e7e175.png";